import React from 'react';
import Image from 'next/image';
import Link from '../Link';
import Wrapper from '../Wrapper';
import {
  Menu,
  MenuItem,
  Badge,
  IconButton,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuFlotante from '../MenuFlotante';
import Buscador from '../Buscador';
import Topbar from '../Topbar';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import useHook from './useHook';
import styles from './styles.module.scss';

const Navbar = () => {

  const {
    productosFavoritos,
    carrito,
    countsReady,
    cartPulse,
    menuIsOpen,
    setMenuIsOpen,
    festividades,
    anchorFest,
    openFest,
    handleOpenFest,
    handleCloseFest,
    isSticky,
    sentinelRef,
  } = useHook();

  return (
    <>
      <Topbar />
      <div ref={sentinelRef} />
      <header role="banner" className={`${styles.header} ${isSticky ? styles.headerSticky : ''}`}>
        <Wrapper>
          <div className={styles.firstLine}>
            <div className={styles.left}>
              <div className={styles.mobileOnly}>
                <IconButton
                  color="black"
                  onClick={() => setMenuIsOpen(true)}
                  style={{ padding: '12px', opacity: 0.7 }}
                  aria-label="Abrir menú"
                >
                  <MenuIcon />
                </IconButton>
              </div>
            </div>
            <div className={styles.center}>
              <Link href="/" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Image
                  className={styles.logo}
                  src="/img/logo-header-2026.png"
                  alt="We Celebrate, el cotillón más lindo, listo para usar!"
                  width={192}
                  height={40}
                  priority
                />
              </Link>
              <div className={styles.desktopOnly}>
                <Buscador />
              </div>
            </div>
            <div className={styles.right}>
              <div className={styles.desktopOnly}>
                <Link href="/wishlist">
                  <button className={styles.botonMenu} aria-label="Mi wishlist">
                    <Badge badgeContent={countsReady ? productosFavoritos?.length : 0} color="black">
                      <FavoriteBorderIcon />
                    </Badge>
                  </button>
                </Link>
              </div>
              <div className={styles.desktopOnly}>
                <Link href="/mi-cuenta">
                  <button className={styles.botonMenu} aria-label="Mi cuenta">
                    <AccountCircleOutlinedIcon />
                  </button>
                </Link>
              </div>
              <Link href="/carrito">
                <button className={styles.botonMenu} aria-label="Mi carrito">
                  <div className={`${styles.pulseWrapper} ${cartPulse ? styles.pulseWrapperActive : ''}`}>
                    <Badge badgeContent={countsReady ? carrito?.length : 0} color="black">
                      <ShoppingBagOutlinedIcon />
                    </Badge>
                  </div>
                </button>
              </Link>
            </div>
          </div>
          <div className={styles.mobileSearchRow}>
            <Buscador />
          </div>
        </Wrapper>
      </header>

      <div className={styles.desktopSecondLine}>
        <Wrapper>
          <div className={styles.secondLine}>
            <Link href="/productos/novedades">
              <button className={styles.botonMenu}>NOVEDADES</button>
            </Link>
            <Link href="/tematicas">
              <button className={styles.botonMenu}>TEMÁTICAS</button>
            </Link>
            <div>
              <button
                className={styles.botonMenu}
                id="festividades-button"
                onClick={handleOpenFest}
                aria-expanded={openFest}
                aria-haspopup="true"
                aria-controls={openFest ? 'festividades-menu' : undefined}
              >
                                FESTIVIDADES
                <span className={`${styles.chevron} ${openFest ? styles.chevronOpen : ''}`}>
                  <ExpandMoreIcon />
                </span>
              </button>

              <Menu
                id="festividades-menu"
                anchorEl={anchorFest}
                open={openFest}
                onClose={handleCloseFest}
                keepMounted
                MenuListProps={{ 'aria-labelledby': 'festividades-button' }}
              >
                {festividades?.map((item: any) => (
                  <MenuItem key={item.id} onClick={handleCloseFest}>
                    <Link href={`/productos/tematica/${item.attributes.slug}`}>
                      {item.attributes.nombre}
                    </Link>
                  </MenuItem>
                ))}
              </Menu>
            </div>
            <Link href="/tienda">
              <button className={styles.botonMenu}>VER TODO</button>
            </Link>
            <Link href="/inspo">
              <button className={styles.botonMenu}>INSPO</button>
            </Link>
            <Link href="/catalogo-mayorista">
              <button className={styles.botonMenu}>MAYORISTAS</button>
            </Link>
          </div>
        </Wrapper>
      </div>

      {menuIsOpen &&
                <MenuFlotante
                  setMenuIsOpen={setMenuIsOpen}
                  itemsInW={productosFavoritos?.length}
                  festividades={festividades}
                />
      }
    </>
  );
};

export default Navbar;
